<template>
    <div>
        <v-autocomplete v-model="selectedData" :items="listData" :hint="hint" :label="label" :itemText="itemText" ref="ctrl"
                  :itemValue="itemValue" :readonly=readonly :error="error" :error-message="errorMessage"></v-autocomplete>
        <div style="color:#ff5252 !important">{{errorMessage[0]}}</div>
    </div>
</template>

<script>
    import axios from "axios";
    import FormJS from "../../../public/plugin/form/form"

    export default {
        name: 'i-selectbox',
        inheritAttrs: false,
        props: {
            icon: {
                type: String,
                default: 'Table'
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            name: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            hint: {
                type: String,
                default: ''
            },
            validate: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String
            },
            items: {
                type: Array,
                default: () => {
                    return []
                }
            },
            itemText: {
                type: String,
                default: ""
            },
            itemValue: {
                type: String,
                default: ""
            },
            value: {
                type: String,
                default: ''
            },
            source: {
                type: String,
                default: ''
            },
            valueField: {
                type: String,
                default: ''
            },
            variable: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            readonly: {
                type: Boolean,
                default: false
            },
            selectAll:{
                type: Boolean,
                default:false
            }
        },
        data: () => {
            return {
                sourceData: null,
                selectedData:null,
                error:false,
                errorMessage:[]
            }
        },
        watch: {
            value: function (data) {
                this.selectedData = data;
                //console.log(this.selectedData);
                this.error=false;
                this.errorMessage=[];
            },

            error: function (data) {
                this.error = data;
            },

            selectedData: function(data){
                this.$emit("input", data);
            },

            source: function () {
                this.getLstDataFromSource();
            }
        },
        methods: {
            getLstDataFromSource() {
                let sql = encodeURI(FormJS.normalizeSQL(this.source,this.variable));
                const prm = axios(process.env.VUE_APP_API_URL + "/workflow/getdata?sql=" + sql);
                axios.post(process.env.VUE_APP_API_URL + "/workflow/getdata?sql=" + sql).then(
                    data=>{
                        if(this.selectAll){
                            let ob = data[0];
                            let empty = {};
                            for(let key in ob){
                                empty[key] = "";
                            }
                            empty[this.itemText] = this.$t('lang.common.all');
                            data.unshift(empty);
                        }

                        this.sourceData = data;

                    }
                );
                /*
                let [data] = Promise.all([prm]);
                //console.log(data);

                if(this.selectAll){
                    let ob = data[0];
                    let empty = {};
                    for(let key in ob){
                        empty[key] = "";
                    }
                    empty[this.itemText] = this.$t('lang.common.all');
                    data.unshift(empty);
                }

                this.sourceData = data;*/
            },

            focus(){
                this.$refs.ctrl.focus();
            }
        },

        computed: {
            listData: function () {
                if (this.source == "" || this.source == undefined) {
                    ////console.log("---items---");
                    ////console.log(this.items);
                    return this.items;
                } else {
                    if(this.sourceData == null){
                        this.getLstDataFromSource();
                    }
                    return this.sourceData;
                }
            }
        },
        created() {
            if (this.source != undefined && this.source != "")
                this.getLstDataFromSource();
        }
    }
</script>
